import React from 'react';
import withReduxContainer, { ContainerProps } from './ZoneGroup.container';
import {
  withSectionContext,
  WithSectionContextProps,
} from '../../../Sections/SectionContext';
import ZoneGroup from './ZoneGroup';
export default withSectionContext(
  withReduxContainer(ZoneGroup)
) as React.ComponentClass<
  Without<ContainerProps, keyof WithSectionContextProps>
>;
